import Components from "slotworks/components/components";
import Contract from "slotworks/utils/contracts/contract";

export function JumpstartSpinCommand(): Contract<void> {
    return Components.matrix.startTransition(true);
}
